<template>
  <div id="menu-component">
    <div id="nav-open" v-on:click="clickmenu">
      <span></span>
    </div>
    <transition name="slide-fade">
      <div class="menu" :class="{active : isActive}" v-show="isActive">
        <ul type="square">
          <span
            v-for="destination in menus"
            :key="destination.path"
            v-show="destination.name != null"
          >
            <router-link tag="li" :to="{path : destination.path}
            ">
              <li class="cursor" v-on:click="clickmenu">{{destination.name}}</li>
            </router-link>
          </span>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Menu",
  props: {
    bgClass: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    isActive: false,
    menus: null
  }),
  mounted() {
    this.setMenu();
  },
  methods: {
    clickmenu() {
      this.isActive = !this.isActive;
    },
    setMenu() {
      this.menus = this.$router.options.routes;
    }
  }
};
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-in;
}
.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.menu {
  z-index: 1;
  width: 120px;
  height: 50%;
  top: 13%;
  right: 1%;
  position: absolute;
  text-align: left;
  border-radius: 3px;
  background-color: rgba(210, 210, 211, 0.8);
}

#nav-open {
  cursor: pointer;
  display: inline-block;
  width: 30px;
  height: 22px;
  vertical-align: middle;
}
/* サイトから丸コピ */
/*ハンバーガーアイコンをCSSだけで表現*/
#nav-open span,
#nav-open span:before,
#nav-open span:after {
  position: absolute;
  height: 3px; /*線の太さ*/
  width: 25px; /*長さ*/
  border-radius: 3px;
  background: #555;
  display: block;
  content: "";
}
#nav-open span:before {
  bottom: -8px;
}
#nav-open span:after {
  bottom: -16px;
}
#menu-component {
  padding: 10px;
}
.cursor {
  margin: 10px 0;
}
.cursor:hover {
  cursor: pointer;
}
</style>